import fetchWithCache from './fetchWithCache';
import normalizeModelMatrix from './normalizeModelMatrix';

const fetchModelMatrix = ({ v3ServicesPath, modelPath, styleId, config }) => {
  const stylePath = styleId ? `/${styleId}` : '';
  const url = `${v3ServicesPath}/matrix-model/${modelPath}${stylePath}`;
  return fetchWithCache(url).then((data) => normalizeModelMatrix(data, config));
};

export default fetchModelMatrix;
